import { ApplicationArea } from '../services/ppv.api'
import { Route, ActivatedRouteSnapshot } from '@angular/router'

export type RoleQuery = {
   application?: ApplicationArea
   roleName?: string | string[]
}

export type CustomData = {
   areaName?: string
   breadcrumb?: string
   requiredRole?: RoleQuery
   mode?: string
}

export interface CustomRoute extends Route {
   data?: CustomData
   children?: CustomRoute[]
}

export type CustomRoutes = CustomRoute[]

export const readRouteData = (route: ActivatedRouteSnapshot) => {
   return route.data as CustomData
}
